export var ContributorType;
(function (ContributorType) {
    ContributorType["Any"] = "any";
    ContributorType["Contributor"] = "contributor";
    ContributorType["Owner"] = "owner";
})(ContributorType || (ContributorType = {}));
//# sourceMappingURL=contributor-type.js.map